import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastService } from './shared/services/toast.service';
import { NetworkService } from './core/services/network.service';
import { filter, pairwise } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgxSpinnerModule],
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'Modernize Angular Admin Template';


  constructor(
    private networkService: NetworkService,
    private toastr: ToastService
  ) { }

  ngOnInit() {
    this.networkService.online$
      .pipe(
        pairwise(), // Get previous and current values
        filter(([prev, curr]) => prev !== curr) // Only if it changed
      )
      .subscribe(([prev, curr]) => {
        if (!curr) {
          this.toastr.errorToast('You are offline');
        } else {
          this.toastr.successToast('Back online');
        }
      });
  }


  // ngOnInit() {
  //   this.networkService.online$.subscribe(isOnline => {
  //     if (!isOnline) {
  //       this.toastr.errorToast('You are offline');
  //     } else {
  //       this.toastr.successToast('Back online');
  //     }
  //   });
  // }
}
